module.exports = __webpack_public_path__ + "static/media/twitter.88046deb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/site-menu/assets/twitter.svg
// module id = 14
// module chunks = 0